import PropTypes from 'prop-types';
import React from 'react';

const ExternalLinkIcon = ({ size, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
    <path d="M11 13l9 -9" />
    <path d="M15 4h5v5" />
  </svg>
);

ExternalLinkIcon.propTypes = {
  size: PropTypes.number,
  style: PropTypes.shape(),
};

ExternalLinkIcon.defaultProps = {
  size: 15,
  style: {},
};

export default ExternalLinkIcon;
